import React from 'react';
import {Button, Container, Grid} from "@mui/material";
import {makeStyles} from '@mui/styles';
import {LocalPhoneOutlined, MailOutlined, PersonOutlined} from "@mui/icons-material";
import Typography from "@mui/material/Typography";
import {lightBlue} from "@mui/material/colors";
import clsx from "clsx";
import {differenceInHours, format, parse} from "date-fns";

const useStyles = makeStyles({
    option:{
        display: 'flex',
        padding:14,
        '-webkit-flex-direction': 'column',
        flexDirection: 'column',
        justifyContent:'center',
        margin:'auto'
    }
});
const fdd = (date)=>{
    let dt = date.split("-");
    const nd = new Date(dt[0],(dt[1]-1),dt[2]);
    return format(nd,'MMMM d, yyyy');
};

function HoldBook({booking, isWidget = false}) {
    const classes = useStyles();
    const bookingTime = format(parse(booking['bookDate'], 'yyyy-MM-dd HH:mm:ss', new Date()), 'HH:mm:ss');
    const depositDate = parse(`${booking['DepositDate']} ${bookingTime}`, 'yyyy-MM-dd HH:mm:ss', new Date());
    const difference = differenceInHours(depositDate, new Date());
    return (
        <Container maxWidth="lg">
            <Grid container direction="column" spacing={3} alignItems={"center"} justify={"center"}>
                <Grid item xs>
                    <Typography variant="h4" component="h4" align="left">
                        Your booking will be on hold until <strong>{format(depositDate,'MMMM d, yyyy')}</strong><br/><br/>
                    </Typography>
                    <Typography variant="h5" component="h5" align="left">
                        We are holding your booking for {difference} hours to make sure nobody steals your spot. If you have any question about the trip, feel free to contact us  by email or phone.
                        <br/><br/><br/>
                    </Typography>
					{!isWidget &&
						<Typography variant="h4" component="h4" align="left">
							How to confirm your booking?<br/>
						</Typography>
					}
                </Grid>
				{!isWidget &&
					<Grid item xs container direction="row" spacing={3} alignItems={"center"} justify={"center"} >
						<Grid item xs>
							<Button sx={{padding:0}} variant={'text'} fullWidth href={`${window['siteUrl']}booking/my-bookings`}>
							<Typography component="h4" variant="h4" align="center" className={clsx({[classes.option]:true,'holdOption':true})}>
								<span style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
									<PersonOutlined style={{width: 74, fontSize: '7.4rem', color:lightBlue[500]}}/>
								</span>
								<strong>Login your account and check trip information</strong>
							</Typography>
							</Button>
						</Grid>
						<Grid item xs>
							<Typography component="h4" variant="h4" align="center" className={clsx({[classes.option]:true,'holdOption':true})}>
								<span style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
									<MailOutlined style={{width: 74, fontSize: '7.4rem', color:lightBlue[500]}}/>
								</span>
								<strong>Click on the link you received in your mailbox</strong>
							</Typography>
						</Grid>
						<Grid item xs>
							<Button sx={{padding:0}} variant={'text'} fullWidth href='tel:+16042411918'>
								<Typography component="h4" variant="h4" align="center" className={clsx({[classes.option]:true,'holdOption':true})}>
									<span style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
										<LocalPhoneOutlined style={{width: 74, fontSize: '7.4rem',color:lightBlue[500]}}/>
									</span>
									<strong>Call our office +1(604)241-1918 Mon-Fri 8am-4:30pm PST</strong>
								</Typography>
							</Button>
						</Grid>
					</Grid>
				}
            </Grid>
        </Container>
    );
}

export default HoldBook;